export default "__VITE_ASSET__CDOhWe7b__"